import styled from 'styled-components';

import Skeleton from '@/components/atom/Skeleton';

const PostItemSkeleton = () => {
  return (
    <Card>
      <Skeleton style={{ width: '20%', height: 28, marginBottom: 16 }} />
      <SpaceBetweenRow>
        <Column style={{ width: '100%' }}>
          <Skeleton style={{ height: 25, marginBottom: 6 }} />
          <Skeleton style={{ width: '80%', height: 25 }} />
        </Column>

        <Skeleton
          style={{ minWidth: 70, height: 70, borderRadius: 16, marginLeft: 16 }}
        />
      </SpaceBetweenRow>
      <SpaceBetweenRow>
        <Row style={{ marginTop: 16, marginBottom: 16 }}>
          <Skeleton
            style={{
              width: 32,
              height: 32,
              borderRadius: '50%',
              marginRight: 12,
            }}
          />
          <Column>
            <Skeleton style={{ width: 100, height: 18, marginBottom: 2 }} />
            <Skeleton style={{ width: 41, height: 18 }} />
          </Column>
        </Row>
        <Row>
          <Skeleton style={{ width: 32, height: 20, marginRight: 16 }} />
          <Skeleton style={{ width: 32, height: 20, marginRight: 16 }} />
        </Row>
      </SpaceBetweenRow>
    </Card>
  );
};

const PostsSkeleton = () => {
  return (
    <Wrapper>
      {Array.from({ length: 10 }).map((_, i) => (
        <PostItemSkeleton key={`skeleton_${i}`} />
      ))}
    </Wrapper>
  );
};

export default PostsSkeleton;

const Wrapper = styled.div`
  padding: 0 20px;
`;

const Card = styled.div`
  padding: 20px 0;
  border-bottom: 1px solid ${({ theme }) => theme.color.gray30};
`;

const Row = styled.div`
  display: flex;
  align-items: center;
`;

const Column = styled.div`
  display: flex;
  flex-direction: column;
`;

const SpaceBetweenRow = styled.div`
  display: flex;
  justify-content: space-between;
`;
